import { useCallback } from 'react';
import { events } from '../services/api';
import { useAuth } from '../contexts/AuthContext';

/**
 * Hook for tracking user events throughout the application
 * 
 * @returns Object with track function
 */
export const useEventTracking = () => {
  const { user } = useAuth();

  /**
   * Track a user event
   * 
   * @param eventType - Type of event (e.g., 'login', 'course_start', 'button_click')
   * @param eventData - Additional data to store with the event
   */
  const track = useCallback((eventType: string, eventData: Record<string, any> = {}) => {
    // Add user info to event data if available
    const enhancedData = {
      ...eventData,
      // Add any additional context data you want to track
      url: window.location.pathname,
      timestamp: new Date().toISOString()
    };

    // Fire and forget - don't wait for response
    events.track(eventType, enhancedData)
      .catch(error => {
        // Just log errors, don't interrupt user experience
        console.error('Error tracking event:', error);
      });
  }, [user]);

  return { track };
};
